// Public DEBUG flag query. The server's DEBUG env var is the source of truth
// (api/src/graphql/query/debugQuery.js); the UI loads it to gate its devLogger.
export default () => `
	debug
`;
